// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a508dcb0","500":"10d2c64c","536":"af89b263","556":"4f404241","787":"d9148eae"}[chunkId] + ".chunk.js";
};